import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ToolbarButton } from './toolbar_button';
import { TooltipMessage } from './toolbar_tooltip_message';
export const BookmarkButton = ({ addBookmark, roundLeftEdgeYn, roundRightEdgeYn, }) => {
    const [bookmarkAdded, setBookmarkAdded] = useState(false);
    useEffect(() => {
        if (bookmarkAdded) {
            setTimeout(() => {
                setBookmarkAdded(false);
            }, 1000);
        }
    }, [bookmarkAdded]);
    const tooltipMessage = bookmarkAdded ? 'Bookmark added!' : 'Add Bookmark';
    const onClick = () => {
        setBookmarkAdded(true);
        addBookmark();
    };
    return (_jsx(ToolbarButton, { "data-testid": "add-bookmark-button", label: "Bookmark", iconName: "AddBookmarkIcon", tooltipMessage: _jsx(TooltipMessage, { text: tooltipMessage }), tooltipStyles: {
            offsetValue: 0,
        }, onClick: onClick, roundLeftEdgeYn: roundLeftEdgeYn, roundRightEdgeYn: roundRightEdgeYn }));
};
//# sourceMappingURL=bookmark_button.js.map